import AbstractService from "./AbstractService";
import FeatureFlagService from "./FeatureFlagService";
import NexusService from "./NexusService";

export default class ChatService extends AbstractService {
	static chatsApi = NexusService.chatsApi;

	static jobEventChatParticipantsApi = NexusService.jobEventChatParticipantsApi;

	static apiCoreEndpointsFeature = 'use_api_core_endpoints_chats';

	static getParticipants(jobEventId) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.jobEventChatParticipantsApi.getJobEventChatParticipants({ jobEventId })
				.then((response) => ({ data : response }));
		}

		return this.get({
			endpoint: `jobevents/${jobEventId}/chat/participants`,
		});
	}

	static mentionUser(data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const chatReq = {};

			if (Object.hasOwn(data, 'UserId')) {
				chatReq.UserId = data.UserId;
			}

			if (Object.hasOwn(data, 'Title')) {
				chatReq.Title = data.Title;
			}

			if (Object.hasOwn(data, 'Message')) {
				chatReq.Message = data.Message;
			}

			if (Object.hasOwn(data, 'Icon')) {
				chatReq.Icon = data.Icon;
			}

			if (Object.hasOwn(data, 'ClickAction')) {
				chatReq.ClickAction = data.ClickAction;
			}

			if (Object.hasOwn(data, 'Parameters')) {
				chatReq.Parameters = data.Parameters;
			}

			return this.chatsApi.sendChatNotification({ chatMessageNotifyPayload : chatReq })
				.then((response) => ({ data : response }));
		}

		return this.post({
			endpoint: "chat/notify",
			data,
		});
	}
}
